
import { Card, Space, Modal, Drawer, Button, Popconfirm, message } from 'antd';
import React, { useState } from 'react';

const DummyPara = () => (
  <div>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
    <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
    <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
  </div>
)

function Modals() {

  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const confirm = () => {
    message.success('Clicked on "Yes"');
  };

  const cancel = () => {
    message.error('Clicked on "No"');
  };

  return (
    <Card title="Modal | Drawer | PopConfirm">
      <Space size="large">
        <Button type="primary" ghost onClick={showModal}>
          Modal
        </Button>

        <Button type="primary" ghost onClick={showDrawer}>
          Drawer
        </Button>

        <Popconfirm
          title="Delete the task"
          description="Are you sure to delete this task?"
          onConfirm={confirm}
          onCancel={cancel}
          okText="Yes"
          cancelText="No"
        >
          <a href="#">Delete</a>
        </Popconfirm>
      </Space>
      <Modal
        title="Basic Modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okType="primary"
        okButtonProps={{ ghost: true }}
        >
        <DummyPara />
      </Modal>

      <Drawer
        title="Drawer with extra actions"
        placement="right"
        width={500}
        onClose={onClose}
        open={open}
        extra={
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" ghost onClick={onClose}>
              OK
            </Button>
          </Space>
        }
      >
        <DummyPara />
      </Drawer>
    </Card>
  )
}


export default Modals;
